<template>
    <div 
        class="o-p-list"
        :style="componentStyles"
    >
        <div class="o-p-list__subtitle">
            {{$t(componentParams.subtitle)}}
        </div>
        <div class="o-p-list__title">
            {{$t(componentParams.title)}}
        </div>
        <div 
            :class="`o-p-list__list ${isEmptyTitle ? 'o-p-list__list--empty-header' : ''}`"
            ref="itemList"
            :style="listStyle"
        >
            <template
                v-for="(category, index) in preparedListItems"
            >
                <APListHeader
                    :key="category.id + index"
                    :first="index === 0"
                    :title="category.name"
                    :style="aPListHeaderParams.style"
                    :params="aPListHeaderParams.params"
                />
                
                <APListItem
                    v-for="(item, i) in category.listItems"
                    :key="item.id + index"
                    :title="item.meta[`name_${locale}`] || item.meta.name"
                    :dark="i === 0 || i % 2 === 0"
                    :floor="item.denormaliseData.floor.level"
                    :nr="item.denormaliseData.unit.name_number"
                    ref="listItem"
                    :floor-color="floorColor[item.denormaliseData.floor.level] || 'var(--a-p-list-item__floor-background, #E66640)'"
                    :customStyle="aPListItemParams.style"
                />
            </template>
            <APListHeader
                :title="$t('componentParams.service', 'Service')"
                :style="aPListHeaderParams.style"
                :params="aPListHeaderParams.params"
            />
        </div>
    </div>
</template>

<script>
import { 
    mapState,
    mapGetters
} from 'vuex'

import {COLUMN_COUNT} from './constants'

import APListItem from '../../atoms/a-p-list-item/a-p-list-item'
import APListHeader from '../../atoms/a-p-list-header/a-p-list-header'

export default {
    name: 'OPList',
    components: {
        APListItem,
        APListHeader
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            aPListItemParams: {},
            aPListHeaderParams: {}
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            'getCategories', 
            'getMapConfigProp',
            'getObjectsByCategoryAZ',
            'getDenormalisedObjectsById'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPList.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPList.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPList.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPList.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        categories() {
            return this.componentParams.categories || []
        },
        preparedListItems() {
            let categories = this.categories
            categories = categories.map(category => {
                const newCategory = category

                newCategory.listItems = []

                this.getCategories.forEach(({id, parent_id: parentId}) => {
                    if(newCategory.id == parentId || id == newCategory.id) {
                        this.getObjectsByCategoryAZ(id).forEach(obj => {
                            if(!newCategory.listItems.some(item => item.id === obj.id)) {
                                newCategory.listItems.push({
                                    ...obj,
                                    denormaliseData: this.getDenormalisedObjectsById(obj.id)[0]
                                })
                            }
                        })
                    }
                });

                newCategory.listItems = newCategory.listItems.filter(item => {
                    return this.activeLevels.includes(item.denormaliseData.floor.level) && this.activeBuildIds.includes(item.denormaliseData.floor.building_index)
                    
                })

                return newCategory
            })
            
            return categories
        },
        columnCount() {
            return +this.componentParams?.columnCount || COLUMN_COUNT
        },
        listStyle() {
            return {
                columnCount: this.columnCount,
            }
        },
        floorColor() {
            return this.getMapConfigProp(`map_views.poster.floor_color`, {})
        },
        activeLevels() {
            return this.getMapConfigProp('map_views.poster.active_levels', []);
        },
        activeBuildIds() {
            return this.getMapConfigProp('map_views.poster.active_building_ids', [])
        },
        isEmptyTitle() {
            return !this.$t(this.componentParams?.title) && !this.$t(this.componentParams?.subtitle)
        }
    },
    methods: {
        getComponentsParams(componentName) {
            return {
                style: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
    },
    mounted() {
        this.aPListItemParams = this.getComponentsParams('APListItem')
        this.aPListHeaderParams = this.getComponentsParams('APListHeader')
    }
}
</script>

<style lang="scss">
@import "o-p-list";
</style>